
import { Language } from "./types";
import { en } from "./languages/en";
import { sl } from "./languages/sl";
import { zh } from "./languages/zh";
import { es } from "./languages/es";
import { ar } from "./languages/ar";
import { fr } from "./languages/fr";
import { de } from "./languages/de";

export const SUPPORTED_LANGUAGES: Language[] = ["en", "sl", "zh", "es", "ar", "fr", "de"];

export const translations = {
  en,
  sl,
  zh,
  es,
  ar,
  fr,
  de
};

export type { Language } from "./types";
export type { TranslationType } from "./types";
